import { render, staticRenderFns } from "./video-stat.vue?vue&type=template&id=90e21ea6&scoped=true"
import script from "./video-stat.vue?vue&type=script&lang=js"
export * from "./video-stat.vue?vue&type=script&lang=js"
import style0 from "./video-stat.vue?vue&type=style&index=0&id=90e21ea6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e21ea6",
  null
  
)

export default component.exports